<template>
   <v-layout align-center justify-center class="upload_bg">
        <v-toolbar fixed flat class="transparent" style="color:white;">
            <v-spacer></v-spacer>
            <v-toolbar-items>       
                <v-btn dark flat @click="closeDialog">Close</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-flex xs12 sm7>  
            <p v-if="error" style="color:red;">{{ errorMessage }}</p> 
            <div class="text-xs-center">
                <p class="subheading white--text">Use a short, descriptive file name.</p>
                <vue-dropzone ref="myVueDropzone" 
                    class="upload_drop"
                    id="dropzone" 
                    v-show="showUpload"
                    :options="dropzoneOptions"
                    v-on:vdropzone-success="uploadSuccess"
                    v-on:vdropzone-file-added="fileAdded"
                    ></vue-dropzone>
            </div>
        </v-flex> 
    </v-layout>
</template>
<script>
    
import axios from 'axios'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import timeOffApi from '@/api/timeoffs'
import pageKeys from '@/common/pagekeys'

export default {
    name: 'upload-attachment',
    components: {
        vueDropzone: vue2Dropzone
    },
    data () {
        return {
            userId: 0,
            loading: false,   
            img: null,   
            showUpload: true,      
            dropzoneOptions: {                    
                url: `${axios.defaults.baseURL}TimeOffs/attachment/upload`,    
                headers: { 
                    "Authorization": `Bearer ${localStorage.token}`,
                    "page_key": pageKeys.timeoff,
                    "session_id": localStorage.sessionId,
                    "source": "Customer"
                },
                addRemoveLinks: true,
                dictDefaultMessage: "<br><b class='headline'><u>Drag and drop your file or click to browse</u><b><br><br><p class='caption'>Maximum 5MB per file.<br>Accepted files types: pdf and images (*.pdf, *.jpg, *.jpeg, *.png)</p>",
                maxFiles: 1,
                acceptedFiles: 'image/jpeg, image/jpg, image/png, application/pdf',
                maxFilesize: 5,   // 5MB
            },
            uploading: false,
            error: false,
            errorMessage: '',
            timeOffId: null,
        }
    },
    methods: {
        setData(timeOffId){
            this.timeOffId = timeOffId
        },
        fileAdded(file) {
            this.loading = true
        },
        async uploadSuccess(file, response) {
            this.error = false
            try{
                //after successful upload, insert attachment details to db
                var data = {
                    timeOffId: this.timeOffId,
                    fileName: response.fileName,
                    description: ""
                }
                const result = await timeOffApi.saveAttachment(data)
                if (result.status == 200) {
                    this.loading = false
                    this.$refs.myVueDropzone.removeAllFiles()
                    this.$emit('send', null)
                    this.$emit('update:dialogUpload', false)
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
                this.loading = false
            }
        },
        closeDialog() {
            this.showUpload=true
            this.$emit('update:dialogUpload', false)
        }
    },        
    created() {}
}
</script>
<style scoped>
 .upload_bg {
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: rgba(0, 0, 0, 0.9)
 }
 .upload_drop {
    height:300px;
    padding:0px 50px 0px 50px;
 }
</style>